// Daily candles from /api/v1/symbols/{symbol} are ascending by timeStamp.

export const CHART_RANGES = ["1M", "3M", "6M", "YTD", "1Y", "5Y", "MAX"];

const MONTHS = { "1M": 1, "3M": 3, "6M": 6, "1Y": 12, "5Y": 60 };

function dayOf(c) {
  return new Date(String(c.timeStamp).slice(0, 10) + "T00:00:00");
}

/** Candles inside the selected range, measured back from the latest candle. */
export function sliceByRange(candles, range) {
  const list = Array.isArray(candles) ? candles.filter((c) => c && c.timeStamp) : [];
  if (!list.length || range === "MAX") return list;
  const last = dayOf(list[list.length - 1]);
  let cutoff;
  if (range === "YTD") {
    cutoff = new Date(last.getFullYear(), 0, 1);
  } else {
    cutoff = new Date(last);
    cutoff.setMonth(cutoff.getMonth() - (MONTHS[range] || 12));
  }
  const out = list.filter((c) => dayOf(c) >= cutoff);
  return out.length > 1 ? out : list.slice(-2);
}

/**
 * Change over a range: { change, pct } or null. The baseline is the last close
 * before the range starts (as brokers report YTD / 1Y returns), so the first
 * session's own move is included; with no earlier candle it is the first close.
 */
export function rangeChange(candles, range) {
  const list = Array.isArray(candles) ? candles.filter((c) => c && c.timeStamp) : [];
  const slice = sliceByRange(list, range);
  if (slice.length < 2) return null;
  const start = list.indexOf(slice[0]);
  const base = Number(start > 0 ? list[start - 1].close : slice[0].close);
  const last = Number(slice[slice.length - 1].close);
  if (!base || isNaN(base) || isNaN(last)) return null;
  return { change: last - base, pct: ((last - base) / base) * 100 };
}
